export default __webpack_public_path__ + "static/media/meet1.1399aad8.png";